import {
  useCloseConsignmentPreviewMutation,
  useCloseConsignmentsMutation,
} from "../../../../../store/apiSlice/shipmentApiSlice";
import { CloseDocumentModal } from "../../../../shared/closeDocument/CloseDocumentModal";

/**
 * Confirm closing consignments with preview blockers and warnings.
 */
export const CloseConsignmentModal = ({ closeModal, orders = [], setSelectedOrder }) => (
  <CloseDocumentModal
    closeModal={closeModal}
    orders={orders}
    setSelectedOrder={setSelectedOrder}
    title="Close shipment"
    submitLabel="Close shipment"
    nounSingular="shipment"
    nounPlural="shipments"
    idKey="consignment_id"
    usePreviewMutation={useCloseConsignmentPreviewMutation}
    useCloseMutation={useCloseConsignmentsMutation}
    previewErrorMessage="Could not load close preview."
    closeErrorMessage="Failed to close shipments."
  />
);
